import { Routes } from '@angular/router';
import { LoginGuard } from './shared/services/login.guard';
import { NoAuthGuard } from './shared/services/no-auth.guard';

export const routes: Routes = [
  {
    path: 'user',
    loadChildren: () => import('./features/user/user.routes').then(m => m.default)
  },
  {
    path: 'ngo',
    loadChildren: () => import('./features/ngo/ngo.routes').then(m => m.default)
  },
  {
    path: 'volunteer',
    loadChildren: () => import('./features/volunteer/volunteer.routes').then(m => m.default)
  },
  {
    path: 'corporate',
    loadChildren: () => import('./features/corporate/corporate.routes').then(m => m.default)
  },
  {
    path: 'login',
    loadComponent: () => import('./shared/common-components/login/login.component').then(m => m.LoginComponent),
    canActivate: [LoginGuard]
  },

  {
    path: 'forgot-password',
    loadComponent: () => import('./shared/common-components/login/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
  },
  {
    path: 'forgot-password/verify',
    loadComponent: () => import('./shared/common-components/login/forgot-password/verify-otp.component').then(m => m.VerifyOtpComponent)
  },
  {
    path: 'landing',
    loadComponent: () => import('./shared/common-components/landing/landing.component').then(m => m.LandingComponent),
    canActivate: [NoAuthGuard]
  },
  {
    path: 'terms-privacy-policy',
    loadComponent: () =>
      import('./shared/common-components/terms-of-use/terms-of-use.component')
        .then(m => m.TermsOfUseComponent)
  },
  { path: '', redirectTo: 'landing', pathMatch: 'full' },
  { path: '**', redirectTo: 'landing' }
];
